module.exports = __webpack_public_path__ + "img/reserve-active.9d93959d.png";